let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bT2HW")).then(() => parcelRequire('6rCd1'));